import { FC, ReactNode } from 'react';

import styles from './FullWidth.module.css';

export const FullWidth: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className,
}) => <div className={`${styles.wrapper} ${className || ''}`}>{children}</div>;
